import { ReactNode, useCallback } from 'react';

import { FUNC_NOOP } from '@libs/constants';
import { CollapseIcon } from '@ui/components/CollapseIcon';
import { GameResultsBadge } from '@ui/components/GameResultBadge';
import { TableCell, TableRow } from '@ui/components/Table';

import { TeamGameMovementRow } from '@features/shared/api/typings';
import { ParticipantsRoundMovementRow } from '@features/tournament/ui/components/RoundMovement/components/ParticipantsRoundMovementRow';
import styles from '@features/tournament/ui/components/RoundMovement/RoundMovement.module.css';

type TeamRoundMovementRowProps = {
  row: TeamGameMovementRow;
  isToggled: boolean;
  is2x2Mode?: boolean;
  toggleTeam: (teamId: string) => void;
  onGameClick?: (gameId: string) => void;
  renderQuickPeekShield?: (userId: string) => ReactNode;
};

export function TeamRoundMovementRow({
  row,
  isToggled,
  is2x2Mode,
  toggleTeam,
  onGameClick,
  renderQuickPeekShield,
}: TeamRoundMovementRowProps) {
  const handleToggle = useCallback(() => {
    toggleTeam(row.team1.teamId);
  }, [toggleTeam, row.team1.teamId]);

  const twoByTwoGameId = is2x2Mode ? row.team1.gameIds[0] : undefined;

  return (
    <>
      <TableRow className={styles.teamRow} clickable hoverable onClick={handleToggle}>
        {row.tableNumber && <TableCell className={styles.no}>{row.tableNumber}</TableCell>}
        <TableCell className={styles.playerName}>
          <div className={styles.teamNameContainer}>
            <span className={styles.teamName}>{row.team1.teamName}</span>
          </div>
        </TableCell>
        <TableCell className={styles.results}>
          <GameResultsBadge
            large
            onGameClick={twoByTwoGameId ? onGameClick : FUNC_NOOP}
            side={row.team1.side}
            gameId={twoByTwoGameId}
            cellResult={row.team1.cellResult}
            score={row.team1.score}
          />

          <GameResultsBadge
            large
            onGameClick={twoByTwoGameId ? onGameClick : FUNC_NOOP}
            side={row.team2.side}
            gameId={twoByTwoGameId}
            cellResult={row.team2.cellResult}
            score={row.team2.score}
          />
        </TableCell>
        <TableCell left className={styles.playerName} onClick={handleToggle}>
          <div className={styles.teamNameContainer}>
            <span className={styles.teamName}>{row.team2.teamName}</span>
            <CollapseIcon toggled={isToggled} />
          </div>
        </TableCell>
      </TableRow>

      {isToggled &&
        row.teamMembers.map((p) => (
          <ParticipantsRoundMovementRow
            key={p.boardNo + p.player1.userId + p.player2.userId}
            row={p}
            isChild
            hasTableNumbers={!!row.tableNumber}
            onGameClick={onGameClick}
            renderQuickPeekShield={renderQuickPeekShield}
          />
        ))}
    </>
  );
}
